'use strict';

angular.module('client.services').factory('ReportingSchoolYearsService', ['$resource', '$log', 'api_server',
  function ($resource, $log, api_server) {
    const reportYearsResource = $resource(api_server + '/reports/report_years');
    let reportYears = null;
    let reportYearsReady = null;

    function loadReportYears() {
      if (!reportYears) {
        reportYears = reportYearsResource.query();
        const request = reportYears;
        reportYearsReady = reportYears.$promise.catch(function (error) {
          if (reportYears === request) {
            reportYears = null;
            reportYearsReady = null;
          }
          $log.error('error in loading reporting school years:', error);
          throw error;
        });
      }
      return reportYearsReady;
    }

    return {
      get: function () {
        loadReportYears();
        return reportYears;
      },
      ready: function () {
        return loadReportYears();
      }
    };
  }]);
